const adminPanel = {
  adminPanel: {
    einAdmin: 'Administracja EIN',
    einInstallerSetup: 'Konfiguracja instalatora EIN',
    installerDataUpdate: 'Aktualizacja danych instalatora',
    uploadFile: 'Prześlij plik',
    chooseFile: 'Wybierz plik',
    installerDataUpdateDescription: 'Udział w rynku instalatorów Enphase, informacje o sponsorach wykonawczych itp.',
    header: 'Linki paska nagłówka',
    platinumTier: 'Poziom platynowy',
    goldTier: 'Poziom złoty',
    silverTier: 'Poziom srebrny',
    same: 'To samo dla wszystkich poziomów',
    bannerDescription: 'Opis baneru',
    bannerLink: 'Link baneru',
    digitalAssets: 'Zasoby cyfrowe',
    name: 'Imię i nazwisko',
    file: 'Plik',
    access: 'Dostęp do kategorii poziomu',
    action: 'Działanie',
    all: 'Wszystkie',
    platinum: 'Platynowy',
    gold: 'Złoty',
    silver: 'Srebrny',
    addDigital: 'Dodaj zasoby cyfrowe',
    productInformation: 'Informacje o produkcie',
    productName: 'Nazwa produktu',
    learnMoreLink: 'Link do dodatkowych informacji',
    featureName: 'Nazwa funkcji A/B',
    featureType: 'Typ funkcji',
    betaRelease: 'Data wprowadzenia wersji beta',
    addProduct: 'Dodaj informacje o produkcie',
    exclusiveUpdate: 'Linki do aktualizacji ekskluzywnej',
    description: 'Opis',
    link: 'Link',
    addLink: 'Dodaj link',
    one: '1',
    two: '2',
    installerList: 'Lista instalatorów dla dostępu do produktów',
    usa: 'Stany Zjednoczone',
    usa_pr: 'Stany Zjednoczone – Portoryko',
    australia: 'Australia',
    belgium: 'Belgia',
    netherlands: 'Holandia',
    germany: 'Niemcy',
    india: 'Indie',
    mexico: 'Meksyk',
    //TODO: translations
    france: 'France',
    //TODO: translations ends
    country: 'Kraj',
    fileName: 'Nazwa pliku',
    software_service: 'USŁUGI_OPROGRAMOWANIA',
    hardware_product: 'PRODUKTY_SPRZĘTOWE',
    empty_file: 'Plik jest pusty',
    invalidFileFormat: 'Nieprawidłowy format pliku',
    invalidFileHeader: 'Nieprawidłowy nagłówek pliku',
    uploadFailed: 'Nie udało się przesłać pliku',
    invalidFile: 'Nieprawidłowy plik',
    errorDetail: {
      one: 'Błąd wiersza: %{errorCount}/%{count}.',
      other: 'Błąd wierszy: %{errorCount}/%{count}.'
    },
    viewError: 'Wyświetl błędy',
    errorListText: 'Lista błędów przesyłania plików',
    companyId: 'Identyfikator firmy',
    message: 'Wiadomość',
    sampleFileName: 'Przykładowy plik'
  }
};

export default adminPanel;
